import { Component, Inject, HostListener } from '@angular/core';
import { EventsServiceInterface } from '../../services/events/events.interface';
import { DOCUMENT } from '@angular/common';
import { ISidebarService } from '../../services/sidebar/sidebar.interface';
import { BrowserWindowRef } from '../../services/window/window.service';
import { AuthServiceInterface } from '../../services/auth/auth-service.interface';
import { IDataService, IParsedDataResponse } from '../../services/data/data-service.interface';
import { RbacServiceInterface } from '../../services/rbac/rbac-service.interface';
import { IConfigurationService } from '../../services/configuration/configuration-service.interface';

@Component({
  selector: 'gtd-nav-panel',
  templateUrl: './nav-panel.component.html',
})
export class NavPanelComponent {
  public isAlertRead = true;
  public isCriticalAlert = false;
  public isDangerAlert = false;
  public latestAlertDate: number;
  public logo: string | null = null;
  public globalData: IParsedDataResponse;
  public hideHelpMenu = false;

  constructor(
    @Inject('EventsServiceInterface') private eventsService: EventsServiceInterface,
    @Inject(DOCUMENT) private dom: Document,
    @Inject(BrowserWindowRef) private window: BrowserWindowRef,
    @Inject('ISidebarService') public sidebarService: ISidebarService,
    @Inject('AuthServiceInterface') private authService: AuthServiceInterface,
    @Inject('RbacServiceInterface') public rbacService: RbacServiceInterface,
    @Inject('IDataService') private dataService: IDataService,
    @Inject('IConfigurationService') public configurationService: IConfigurationService
  ) {
    this.logo = this.authService.userData().logo;
    this.globalData = this.dataService.getData();
    this.initWhiteLabelOptions();
  }

  @HostListener('document:click', ['$event'])
  @HostListener('document:touch', ['$event'])
  handleOutsideClick(event) {
    if (this.sidebarService.getMenuSection() === 'menu' || this.window.nativeWindow.innerWidth < 481) {
      return;
    }
    const popups = Array.from(this.dom.querySelectorAll('.c-menu-list'));
    if (!popups.some((popup) => popup.contains(event.target))) {
      this.sidebarService.setMenuSection('menu');
    }
  }

  openCrmSwitchModal(): void {
    this.eventsService.broadcast('isOpenSelector:toggle');
  }

  openMenuSection(buttonName: string): void {
    setTimeout(() => {
      this.sidebarService.setMenuSection(buttonName);
    }, 0);
  }

  closeSidebar(): void {
    this.eventsService.broadcast('sidebarComponent:toggle');
  }

  initWhiteLabelOptions(): void {
    try {
      const settings = JSON.parse(
        this.configurationService.data().brand.affiliate_crm_signin_signup_pages_settings
      ).affiliate_crm_login_settings;
      this.hideHelpMenu = settings.affiliate_crm_hide_help;
    } catch {}
  }
}
